/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Create_Note_Hint_PrefixInputs */

const en_read_along_create_note_hint_prefix = /** @type {(inputs: Read_Along_Create_Note_Hint_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can create a note by accessing your file and clicking the`)
};

const es_read_along_create_note_hint_prefix = /** @type {(inputs: Read_Along_Create_Note_Hint_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes crear una nota entrando en tu archivo y haciendo clic en el botón`)
};

/**
* | output |
* | --- |
* | "You can create a note by accessing your file and clicking the" |
*
* @param {Read_Along_Create_Note_Hint_PrefixInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_create_note_hint_prefix = /** @type {((inputs?: Read_Along_Create_Note_Hint_PrefixInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Create_Note_Hint_PrefixInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_create_note_hint_prefix(inputs)
	return en_read_along_create_note_hint_prefix(inputs)
});